import React from 'react';
export default function AdviceServices() {
  return (
    <div className="programme-detail advice-modern" style={{maxWidth: 900, margin: '0 auto', padding: '2.5em 1em'}}>
      <div className="advice-hero" style={{background: 'linear-gradient(120deg, #f7e6ee 0%, #e6f7f2 100%)', borderRadius: 18, padding: '2.5em 2em 2em 2em', boxShadow: '0 4px 24px rgba(123,30,58,0.10)', textAlign: 'center', marginBottom: 36}}>
        <h1 style={{color: '#7b1e3a', fontWeight: 900, fontSize: '2.2rem', marginBottom: 10}}>Advice Services</h1>
        <p style={{color: '#3a6c5a', fontSize: '1.18rem', maxWidth: 650, margin: '0 auto'}}>
          Free, confidential advice for the Crumlin Road community for over 38 years. Our experienced team is here to help with benefits, housing, debt, and more.
        </p>
      </div>
      <div className="advice-features" style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '2em', margin: '2.5em 0'}}>
        <div className="feature-card" style={{background: '#fff', borderRadius: 14, boxShadow: '0 2px 12px rgba(123,30,58,0.08)', padding: '1.5em 1em', textAlign: 'center'}}>
          <h3 style={{color: '#7b1e3a', fontWeight: 800, fontSize: '1.1rem'}}>Benefits & Allowances</h3>
          <ul style={{listStyle: 'none', padding: 0, margin: 0, color: '#3a6c5a'}}>
            <li>Income Support</li>
            <li>Housing Benefit</li>
            <li>Disability Living Allowance</li>
            <li>Incapacity Benefit</li>
            <li>Attendance Allowance</li>
            <li>Tax Credits</li>
            <li>Social Fund</li>
          </ul>
        </div>
        <div className="feature-card" style={{background: '#fff', borderRadius: 14, boxShadow: '0 2px 12px rgba(123,30,58,0.08)', padding: '1.5em 1em', textAlign: 'center'}}>
          <h3 style={{color: '#3a6c5a', fontWeight: 800, fontSize: '1.1rem'}}>Housing & Employment</h3>
          <ul style={{listStyle: 'none', padding: 0, margin: 0, color: '#7b1e3a'}}>
            <li>Housing Issues</li>
            <li>Employment</li>
            <li>Debt</li>
            <li>Consumer Issues</li>
          </ul>
        </div>
        <div className="feature-card" style={{background: '#fff', borderRadius: 14, boxShadow: '0 2px 12px rgba(123,30,58,0.08)', padding: '1.5em 1em', textAlign: 'center'}}>
          <h3 style={{color: '#e67c30', fontWeight: 800, fontSize: '1.1rem'}}>Support & Representation</h3>
          <ul style={{listStyle: 'none', padding: 0, margin: 0, color: '#3a6c5a'}}>
            <li>Help with forms & letters</li>
            <li>Telephone calls on your behalf</li>
            <li>Tribunal & Appeals support</li>
            <li>Money advice worker</li>
          </ul>
        </div>
      </div>
      <div className="advice-contact" style={{background: '#f7e6ee', borderRadius: 12, padding: '1.5em 2em', color: '#7b1e3a', fontWeight: 600, textAlign: 'center', margin: '2.5em 0 0 0'}}>
        <span>Contact Heather, Sonya or Andy on <a href="tel:02890351020">(028) 9035 1020</a> for assistance or to make an appointment.</span>
      </div>
    </div>
  );
}